import React from 'react';
import { Button } from 'antd';
import SVG from 'react-inlinesvg';
import cx from 'classnames';

export const OAuthButton = ({
  title,
  provider,
  onClick,
  className,
}) => {
  let svgNode = null;
  if (provider === 'facebook') { svgNode = <SVG className="oauth-btn-icon mr-2 d-flex" src={require('assets/media/auth/oauth-facebook-logo.svg')} /> }
  else if (provider === 'google') { svgNode = <SVG className="oauth-btn-icon mr-2 d-flex" src={require('assets/media/auth/oauth-google-logo.svg')} /> }
  else if (provider === 'twitter') { svgNode = <SVG className="oauth-btn-icon mr-2 d-flex" src={require('assets/media/auth/oauth-twitter-logo.svg')} /> }
  return (
    <Button
      type="default" block size="large"
      className={cx(
        "d-flex flex-row align-items-center",
        className,
      )}
      onClick={onClick}
    >
      { svgNode }
      <div className="flex-grow-1 mr-3">{ title }</div>
    </Button>
  );
};



// WEBPACK FOOTER //
// ./scripts/presentation/OAuthButton.jsx